'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

exports['default'] = _nonIterableSpread;
//# sourceMappingURL=nonIterableSpread.js.map
